import { createFileRoute } from "@tanstack/react-router";
import { ThemeUtilitiesGuide } from "@/utils/design-system/examples-exports";

export const Route = createFileRoute(
  "/demo/design-system/theming/theme-utilities",
)({
  component: ThemeUtilitiesGuide,
});
